import type { TModernTheme } from '@modern/theme/modern-theme.types';
import { metricsBaseTheme } from '@modern/theme/themes/base/metrics-base-theme';
import { shadowBaseTheme } from '@modern/theme/themes/base/shadow-base-theme';
import { typographyBaseTheme } from '@modern/theme/themes/base/typography-base-theme';
import { darkColors } from '@modern/theme/themes/colors/dark-theme';

export const modernTheme: TModernTheme = {
  color: darkColors,
  font: typographyBaseTheme,
  metrics: metricsBaseTheme,
  shadow: shadowBaseTheme,
};
